import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updatePreviewStep } from 'redux/modules/adBuilder';
import Paper from 'material-ui/Paper';
import { IntroPreview, QuestionsPreview, PrivacyPolicyPreview, ThankYouPreview } from 'components/AdBuilder/LeadFormPreviews';
import * as styles from './Previews.scss';
var LeadFormPreview = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    adBuilder: state.adBuilder,
    theme: state.theme
  };
}, {
  updatePreviewStep: updatePreviewStep
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(LeadFormPreview, _Component);

  var _super = _createSuper(LeadFormPreview);

  function LeadFormPreview() {
    var _this;

    _classCallCheck(this, LeadFormPreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleStepBtnClick", function (direction) {
      var builder = _this.props.builder;

      if (direction === 'prev' && builder.previewStep !== 'intro') {
        if (builder.customDisclaimerEnabled && builder.previewStep === 'thanks') {
          _this.changePreviewPane('privacy');
        } else {
          _this.changePreviewPane('intro');
        }
      } else if (direction === 'next' && builder.previewStep !== 'thanks') {
        if (builder.customDisclaimerEnabled && builder.previewStep === 'intro') {
          _this.changePreviewPane('privacy');
        } else {
          _this.changePreviewPane('thanks');
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changePreviewPane", function (previewName) {
      _this.props.changeField('previewStep', previewName);
    });

    _defineProperty(_assertThisInitialized(_this), "mapAccordionTabToName", function (tab) {
      if (tab === 3) return 'thanks';

      if (tab === 2 && _this.props.builder.customDisclaimerEnabled) {
        return 'privacy';
      }

      return 'intro';
    });

    return _this;
  }

  _createClass(LeadFormPreview, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.builder.contentAccordionTab !== nextProps.builder.contentAccordionTab) {
        var previewPane = this.mapAccordionTabToName(nextProps.builder.contentAccordionTab);
        this.changePreviewPane(previewPane);
      }

      if (this.props.builder.customDisclaimerEnabled !== nextProps.builder.customDisclaimerEnabled) {
        if (nextProps.builder.customDisclaimerEnabled) {
          this.changePreviewPane('privacy');
        } else {
          this.changePreviewPane('intro');
        }
      }
    }
    /** *********************************************************
     EVENT HANDLERS
     ***********************************************************/

  }, {
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          accordionTab = _this$props.accordionTab,
          builder = _this$props.builder;
      var fbPage = this.props.organization.SocialAccounts.filter(function (a) {
        return a.platform === 'Facebook page';
      })[0];
      var stepTitle = 'Form';
      var stepCount = builder.customDisclaimerEnabled ? '1 of 3' : '1 of 2';
      var buttonText = 'Next';

      if (builder.previewStep === 'privacy' && builder.customDisclaimerEnabled) {
        stepTitle = 'Custom Disclaimer';
        stepCount = '2 of 3';
        buttonText = 'Submit';
      }

      if (builder.previewStep === 'thanks') {
        stepCount = builder.customDisclaimerEnabled ? '3 of 3' : '2 of 2';
        stepTitle = 'Thank You Screen';
        buttonText = builder.thankYouButtonText ? builder.thankYouButtonText : 'View Website';
      }

      var imageUrl = this.props.adBuilder.adImage && builder.introImageType === 'adForm' ? this.props.adBuilder.adImage[0].fullyQualifiedUrl : builder.imageUrl;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: styles.formPreviewLabel
      }, "Form Preview"), /*#__PURE__*/React.createElement(Paper, {
        style: {
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.image,
        style: {
          backgroundImage: "url(".concat(imageUrl, ")")
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.pageInfo
      }, /*#__PURE__*/React.createElement("img", {
        className: styles.pageInfoAvatar,
        src: fbPage.avatarImageUrl
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.pageInfoName
      }, fbPage.username)), builder.previewStep === 'intro' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IntroPreview, {
        formValues: builder
      }), /*#__PURE__*/React.createElement(QuestionsPreview, {
        formValues: builder
      }), !builder.customDisclaimerEnabled && /*#__PURE__*/React.createElement(PrivacyPolicyPreview, {
        formValues: builder,
        pageInfo: fbPage
      })), builder.previewStep === 'privacy' && /*#__PURE__*/React.createElement(PrivacyPolicyPreview, {
        formValues: builder,
        pageInfo: fbPage
      }), builder.previewStep === 'thanks' && /*#__PURE__*/React.createElement(ThankYouPreview, {
        formValues: builder
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.submitButton
      }, buttonText), /*#__PURE__*/React.createElement("div", {
        className: styles.bottomWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.bottomLabel
      }, stepTitle), /*#__PURE__*/React.createElement("div", {
        className: styles.navButtonWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.bottomStepCount
      }, stepCount), /*#__PURE__*/React.createElement("div", {
        className: builder.previewStep === 'intro' ? "".concat(styles.disabled, " ").concat(styles.navButton) : styles.navButton,
        onClick: function onClick() {
          return _this2.handleStepBtnClick('prev');
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-caret-left ".concat(styles.navButtonIcon)
      })), /*#__PURE__*/React.createElement("div", {
        className: builder.previewStep === 'thanks' ? "".concat(styles.disabled, " ").concat(styles.navButton) : styles.navButton,
        onClick: function onClick() {
          return _this2.handleStepBtnClick('next');
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-caret-right ".concat(styles.navButtonIcon)
      }))))));
    }
  }]);

  return LeadFormPreview;
}(Component), _defineProperty(_class2, "defaultProps", {
  builder: {
    imageUrl: 'http://bit.ly/2kpJ4U1'
  }
}), _temp)) || _class);
export default LeadFormPreview;